import apiClient from './apiClient';

export const convertHardness = async ({
  value,
  scale,
  materialModel = 'steel',
  includeExtended = false,
}, options = {}) => {
  const response = await apiClient.get('/hardness/convert', {
    params: { value, scale, materialModel, includeExtended },
    signal: options.signal,
  });
  return response.data;
};
